import { Alert, Card, Spin } from 'antd';
import _ from 'lodash';
import { computed, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { CarObject } from 'stores/Classes';

class CarAppointments extends Component {
  observableCar = null;

  constructor(props) {
    super(props);

    this.observableCar = observable.box(props.car);

    makeObservable(this, {
      formattedAppointments: computed,
      observableCar: observable,
    });
  }

  async componentDidMount() {
    if (this.props.car) {
      this.observableCar.set(this.props.car);
    }

    await this.getCarAppointments();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.car !== this.props.car && this.props.car) {
      this.observableCar.set(this.props.car);
    }
  }

  getCarAppointments = async () => {
    const car = this.observableCar.get();

    if (!car) return;

    if (!car.service_appointment.loaded) {
      await car.getAppointments();
    }

    if (!car.routineAppointments.loaded) {
      await car.getRoutineAppointments();
    }
  };

  get formattedAppointments() {
    const car = this.observableCar.get();

    if (!car) return [];

    let appointments = _.map(car.service_appointment.data, (item) => {
      return {
        date: moment(item.appointmentDate).format('lll'), // Changed key to 'date' for consistency
        state: item.state,
        comments: item.comments,
      };
    });

    let routineAppointments = _.map(car.routineAppointments.data, (item) => {
      return {
        date: moment(item.appointment.appointmentDate).format('lll'),
        state: item.title,
        comments: item.appointment.comments,
      };
    });

    return [...appointments, ...routineAppointments];
  }

  render() {
    const car = this.observableCar.get();

    if (!car) {
      return <Alert message="No car data available" type="warning" showIcon />;
    }

    if (car.service_appointment.isError || car.routineAppointments.isError) {
      return <Alert message="Unable to fetch services" type="error" showIcon />;
    }

    if (!car.service_appointment.loaded || car.routineAppointments.pending) {
      return <Spin />;
    }

    const appointments = this.formattedAppointments;

    if (_.isEmpty(appointments)) {
      return <Alert message="No services were found" type="info" showIcon />;
    }

    return (
      <>
        <h4>Appointments</h4>

        {_.map(appointments, (appointment, i) => (
          <Card key={i} title={appointment.state}>
            <p>
              <strong>Date:</strong> {appointment.date}
            </p>
            <p>
              <strong>Comments:</strong> {appointment.comments}
            </p>
          </Card>
        ))}
      </>
    );
  }
}

CarAppointments.propTypes = {
  car: PropTypes.instanceOf(CarObject),
};

export default observer(CarAppointments);
